import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorSinkService, UiProgressPromiseService } from 'ngx-zcs-components';

import { BatchWriterService } from '../../services/batch-writer.service';
import { ConfigFormBase } from '../config-form-base';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    TranslateModule,
  ],
  selector: 'app-config-form-material',
  templateUrl: './config-form-material.component.html',
  styleUrls: ['./config-form-material.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigFormMaterialComponent extends ConfigFormBase {
  constructor(
    batchWriter: BatchWriterService,
    cdr: ChangeDetectorRef,
    errorSink: ErrorSinkService,
    uiProgressPromiseService: UiProgressPromiseService,
  ) {
    super(batchWriter, cdr, errorSink, uiProgressPromiseService);
  }
}
